export default __webpack_public_path__ + "static/media/SvgInfo.ca4524af.svg";